import Vue from 'vue'
import Router from 'vue-router'
var title = "欧华美科"

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
      document.getElementById("mainTitle").innerHTML = title+"-首页"
      next()
    }
  },{
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-首页"
        next()
    } 
  },{
    path: '/medical',
    name: 'medical',
    component: resolve => require(['@/pages/product/product1'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-产品中心-医疗"
        next()
    } 
  },{
    path: '/home',
    name: 'home',
    component: resolve => require(['@/pages/product/product2'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-产品中心-家用"
        next()
    } 
  },{
    path: '/about',
    name: 'about',
    component: resolve => require(['@/pages/about/about'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-关于我们"
        next()
    } 
  },{
    path: '/joinUs',
    name: 'joinUs',
    component: resolve => require(['@/pages/about/joinUs'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-加入我们"
        next()
    } 
  },{
    path: '/active',
    name: 'active',
    component: resolve => require(['@/pages/active/active'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-对外活动"
        next()
    } 
  },{
    path: '/activeDetail',
    name: 'activeDetail',
    component: resolve => require(['@/pages/active/detail'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-活动详情"
        next()
    } 
  },{
    path: '/search',
    name: 'search',
    component: resolve => require(['@/pages/search/search'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-信息查验"
        next()
    } 
  },{
    path: '/result',
    name: 'result',
    component: resolve => require(['@/pages/search/result'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-信息查验结果"
        next()
    } 
  },{
    path: '/owner/:type',
    name: 'owner',
    component: resolve => require(['@/pages/owner/owner'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-主理人"
        next()
    } 
  },{
    path: '/ownerList',
    name: 'ownerList',
    component: resolve => require(['@/pages/owner/list'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-主理人列表"
        next()
    } 
  },{
    path: '/ownerDetail',
    name: 'ownerDetail',
    component: resolve => require(['@/pages/owner/detail'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-主理人详情"
        next()
    } 
  },{
    path: '/ownerSearch',
    name: 'ownerSearch',
    component: resolve => require(['@/pages/owner/search'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-搜做主理人"
        next()
    } 
  }],
  // mode:'history'   //去除#号
})



// WEBPACK FOOTER //
// ./src/router/index.js